import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ShellLayout } from "./components/layout/shell-layout";
import { LoginPage } from "./features/auth/login.page";
import { Dashboard } from "./features/dashboard/dashboard.page";
import { CasesPage } from "./features/cases/cases.page";
import { CaseDetailPage } from "./features/cases/case-detail.page";
import { ApplicationsPage } from "./features/applications/applications.page";
import { TasksPage } from "./features/tasks/tasks.page";
import { ProgramsPage } from "./features/programs/programs.page";
import { ParticipantsPage } from "./features/participants/participants.page";
import { PaysheetsPage } from "./features/paysheets/paysheets.page";
import { UsersPage } from "./features/users/users.page";
import { AuditLogsPage } from "./features/audit-logs/audit-logs.page";
import { SearchResultsPage } from "./features/search/search-results.page";
import { ProgramModulesPage } from "./features/program-modules/program-modules.page";
import { useAuthStore } from "./store/auth-store";
import { ErrorBoundary } from "./components/ErrorBoundary";

const App = () => {
  const bootstrap = useAuthStore((state) => state.bootstrap);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/" element={<ShellLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="cases" element={<CasesPage />} />
          <Route path="cases/:id" element={<CaseDetailPage />} />
          <Route path="applications" element={<ApplicationsPage />} />
          <Route path="paysheets" element={<PaysheetsPage />} />
          <Route path="tasks" element={<TasksPage />} />
          <Route path="programs" element={<ProgramsPage />} />
          <Route path="participants" element={<ParticipantsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="search" element={<SearchResultsPage />} />
          <Route path="program-modules" element={<ProgramModulesPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
